// src/components/tableLayout/tableLayout.js
import React from "react";
import "./tableLayout.css";

function TableLayout({ toolbar, children }) {
  return (
    <>
      {toolbar && <div className="tpl-toolbar-wrapper">{toolbar}</div>}
      <div className="tpl-table-wrapper">{children}</div>
    </>
  );
}

export default TableLayout;
